import { render, staticRenderFns } from "./ObiCol.vue?vue&type=template&id=1d844a87&scoped=true&"
import script from "./ObiCol.vue?vue&type=script&lang=js&"
export * from "./ObiCol.vue?vue&type=script&lang=js&"
import style0 from "./ObiCol.vue?vue&type=style&index=0&id=1d844a87&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d844a87",
  null
  
)

export default component.exports